// extracted by mini-css-extract-plugin
export default {"main":"MsgBox_main__zfAXC","emoji":"MsgBox_emoji__M-yN+"};